import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import SEO from '../../components/shared/SEO';
// import { authAPI } from '../services/api'; // Use your real API

export default function CliAuth() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { user } = useAuth(); // Assume you have this context
    const [status, setStatus] = useState('loading'); // loading | success | error

    const redirectUri = searchParams.get('redirect_uri');

    useEffect(() => {
        // 1. If not logged in, force login (redirect)
        if (!user) {
            // 1. Get the CLI callback URL (e.g., http://localhost:4200/callback)
            const cliCallback = searchParams.get('redirect_uri');

            // 2. Create the clean Return URL: "/cli/auth?redirect_uri=..."
            // We HARDCODE "/cli/auth" so it never accidentally grabs "/login"
            const cleanReturnPath = `/cli?redirect_uri=${cliCallback}`;

            // 3. Redirect to Login
            navigate(`/login?returnUrl=${encodeURIComponent(cleanReturnPath)}`);
            return;
        }

        // 2. Generate Token & Redirect Back to CLI
        const performHandshake = async () => {
            try {
                // SIMULATION: Fetch a fresh token for the CLI
                // const { token } = await authAPI.generateCliToken(); 

                // Mock Token for now
                const token = "edkl_live_" + Math.random().toString(36).substring(2);

                if (redirectUri) {
                    // 3. THE MAGIC: Redirect browser to localhost:4200
                    window.location.href = `${redirectUri}?token=${user?.token}&name=${encodeURIComponent(user?.name)}&email=${encodeURIComponent(user?.email)}`;
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            } catch (err) {
                console.error(err);
                setStatus('error');
            }
        };

        if (user && redirectUri) {
            performHandshake();
        }
    }, [ user, redirectUri, navigate]);

    return (
        <>
        <SEO title="CLI Linkage | Secure Terminal Connect" description="Authorizing your local terminal session. Please confirm the handshake to link your machine to EnvDock." />
        
        <div className="min-h-screen bg-black flex flex-col items-center justify-center text-white">
            {status === 'loading' && (
                <>
                    <Loader2 className="animate-spin text-indigo-500 mb-4" size={48} />
                    <h1 className="text-xl font-medium">Authenticating CLI...</h1>
                    <p className="text-gray-500 text-sm mt-2">Please wait while we connect your terminal.</p>
                </>
            )}

            {status === 'success' && (
                <>
                    <CheckCircle className="text-green-500 mb-4" size={48} />
                    <h1 className="text-xl font-medium">Authentication Successful</h1>
                    <p className="text-gray-500 text-sm mt-2">Redirecting you back to the terminal...</p>
                </>
            )}

            {status === 'error' && (
                <>
                    <XCircle className="text-red-500 mb-4" size={48} />
                    <h1 className="text-xl font-medium">Authentication Failed</h1>
                    <p className="text-gray-500 text-sm mt-2">Could not connect to local terminal.</p>
                </>
            )}
        </div>
        </>
    );
}